import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/**
 * The files filed on a return run — today that is its sheet, one PDF carrying a page per lorry.
 * Read through the generic files API, which every member of the organisation reads.
 *
 * One file is the normal case: every write that moves the run's fleet renders the sheet again and
 * removes the one it replaced, so the list holds the document the drivers are actually taking.
 */
export function useReturnOrderFiles(returnOrderId: string) {
	/** Query */
	const query = useQuery({
		queryKey: ["return-order-files", returnOrderId],
		queryFn: async () => {
			const response = await client.files[":tableName"][":key"][":identifier"].$get({
				param: {
					tableName: "returnOrderFiles",
					key: "returnOrderId",
					identifier: returnOrderId,
				},
			});
			const data = await responseHandler(response);
			return data.files;
		},
	});

	/** Return */
	return { ...query, files: query.data ?? [] };
}
